import { Text } from "$components";
import TextType from "$components/Text/TextType";
import { theme } from "$utils/theme/bataillog";
import Block from "./Block";
import sections from "./sections";
import Divider from "./Divider";

const textSection = sections.find((s) => s.id === "texts");

function Texts() {
  const fonts = theme.font;
  return (
    <Block title={textSection.label} id={textSection.id}>
      <Text>
        <i>Les marges sont présentes par défaut pour chaque texte.</i>
      </Text>

      <Divider />

      {Object.values(TextType).map((textType) => (
        <Text key={textType} type={textType}>
          Texte {textType}
        </Text>
      ))}

      <Divider />

      <Text type="h3">Polices</Text>
      {Object.keys(fonts).map((fontName, i) => (
        <Text
          key={fontName}
          style={{
            fontFamily: fonts[fontName],
            fontSize: 20,
            marginBottom:
              i < Object.keys(fonts).length - 1 ? theme.spacing(2) : 0,
          }}
        >
          {fontName} : The quick brown fox jumps over the lazy dog
        </Text>
      ))}
    </Block>
  );
}

export default Texts;
